import { Injectable, Input, EventEmitter } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { MetaDataCache } from '../Models/CommonModels';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest, GuestSearch, AddPreferenceRequest, CurrentReservationSearch, GuestAlert, UploadImageRequest, ReservationStatusCount, ReservationTracesRequest, VisitorSearch } from '../Models/RequestModels';
import { UIState, UserState, ModuleMultilingualLabels } from '../Models/UIModels';
import { AppSettings } from '../Library/AppSettings';
import { StaffBasicInfo } from '../Models/GlobalEntities';
import { GuestLookup, ListResponse, Staff_Search_Assigment, SimpleResponse, ReservationTrace } from '../Models/ResponseModels';
import { MasterDataService } from './MasterDataService';
import { EntityCodes } from '../Models/EnumModels';
import { TranslateService } from '@ngx-translate/core';
import { groupBy } from 'lodash/fp';
import { DateTime } from 'luxon';
import { UUID } from 'angular2-uuid';

@Injectable()
export class PMSService extends BaseService {
    private Version: number;
    public Cache_GuestLook: any = {};
    public GuestLookupChanged = new EventEmitter<number>();
    public GuestImageUpdated = new EventEmitter<boolean>();
    private translate: TranslateService;

    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService) {
        super();
        this.BaseURL = AppSettings.URL_PMSService;

    }

    GetGuestLookup(PropertyID: number): Array<GuestLookup> {
        let arr = new Array<GuestLookup>();
        if (this.Cache_GuestLook[PropertyID] != null)
            arr = this.Cache_GuestLook[PropertyID];
        return arr;
    }

    SortGuestLook(Data: Array<GuestLookup>): void {
        //console.info(Data);
        
        if (Data == null || Data.length == 0)
            return;

        Data.sort((a, b) => {
            if (a.FullName > b.FullName) {
                return 1
            }

            if (a.FullName < b.FullName) {
                return -1
            }

            return 0;
        });
    }

    SetGuestLookupCache(Data: Array<GuestLookup>): void {
        if (Data == null)
            return;

        if (Data.length == 0)
            return;

        let propID = Data[0].PropertyId;

        this.Cache_GuestLook[propID] = Data;

        this.SortGuestLook(this.Cache_GuestLook[propID]);
        this.GuestLookupChanged.emit(propID);
    }

    GuestLookup_FindByReservationID(PropertyId: number, ReservationId: number): GuestLookup {
        let lst = this.Cache_GuestLook[PropertyId];
        for (let i = 0; i < lst.length; i++) {
            let row: GuestLookup = lst[i];
            if (row.TritonReservationId == ReservationId)
                return row;
        }

        return null;
    }

    GuestLookup_FindByReservationID_Index(PropertyId: number, ReservationId: number): number {
        let lst = this.Cache_GuestLook[PropertyId];
        for (let i = 0; i < lst.length; i++) {
            let row: GuestLookup = lst[i];
            if (row.TritonReservationId == ReservationId)
                return i;
        }

        return -1;
    }

    DeleteFromGuestLookupCache(PropertyID: number, TritonReservationId: number): void {
        //console.info(this.Cache_GuestLook[PropertyID]);
        //console.info(Data);

        if (this.Cache_GuestLook[PropertyID] == null) {
            return;
        }

        let cData: Array<GuestLookup> = this.Cache_GuestLook[PropertyID];

        let lst = cData.filter(a => a.TritonReservationId == TritonReservationId);

        for (let i = 0; i < lst.length; i++) {
            let row: GuestLookup = lst[i];

            let idx: number = this.GuestLookup_FindByReservationID_Index(PropertyID, row.TritonReservationId);
            if (idx >= 0) {
                this.Cache_GuestLook[PropertyID].splice(idx, 1);
            }
        }

        //this.SortGuestLook(this.Cache_GuestLook[PropertyID]);
        this.GuestLookupChanged.emit(PropertyID);
    }

    AddToGuestLookupCache(PropertyID: number, Data: Array<GuestLookup>): void {
        //console.info(this.Cache_GuestLook[PropertyID]);
        //console.info(Data);

        if (Data == null)
            return;

        if (Data.length == 0)
            return;

        if (this.Cache_GuestLook[PropertyID] == null) {
            this.Cache_GuestLook[PropertyID] = Data;
        }
        else {
            let cData: Array<GuestLookup> = this.Cache_GuestLook[PropertyID];

            for (let i = 0; i < Data.length; i++) {
                let row: GuestLookup = Data[i];

                let idx: number = this.GuestLookup_FindByReservationID_Index(PropertyID, row.TritonReservationId);
                //console.info("I = " + idx);

                if (idx < 0)
                    cData.push(row);
                else
                    cData[idx] = row;
            }

            //console.info(cData);

            this.Cache_GuestLook[PropertyID] = cData;
        }



        this.SortGuestLook(this.Cache_GuestLook[PropertyID]);
        this.GuestLookupChanged.emit(PropertyID);
    }

    GuestLookup_MaxVersion(PropertyID: number): number {
        if (this.Cache_GuestLook[PropertyID] == undefined || this.Cache_GuestLook[PropertyID] == null)
            return null;

        let cData: Array<GuestLookup> = this.Cache_GuestLook[PropertyID];
        if (cData == undefined || cData == null)
            return null;

        let max: number = 0;

        for (let i = 0; i < cData.length; i++) {
            if (cData[i].Version > max)
                max = cData[i].Version;
        }

        return max;
    }

    public GuestLookup_Search(req: GuestSearch): Promise<Array<GuestLookup>> {
        return this.apiService.postAPI(this.BaseURL, "PMS/GuestLookup_Search", req, false).then(data => {
            if (data.HasError == true) {
                return null;
            }

            for (let i = 0; i < data.Result.length; i++) {
                let row = data.Result[i];
                let loc = this.masterService.FindLocation(row.PropertyId, row.LocationId);
                if (loc == null) {
                    row.LocationDescription = "";
                }
                else {
                    row.LocationDescription = loc.Description;
                }
            }

            return data;
        });
    }

      public VisitorLookup_Search(req: VisitorSearch): Promise<Array<GuestLookup>> {
        return this.apiService.postAPI(this.BaseURL, "PMS/VisitorsLookUp", req, false).then(data => {
            if (data.HasError == true) {
                return null;
            }
            return data;
        });
    }

    public GuestLookup_Get(PropertyID: number, versionRequired = true): Promise<Array<GuestLookup>> {
        let version = null;
        if (PropertyID != null)
            version = versionRequired ? this.GuestLookup_MaxVersion(PropertyID) : null;

        return this.apiService.getAPI(this.BaseURL, "PMS/GuestLookup_Get?PropertyID=" + this.URLEncode(PropertyID) + "&Version=" + this.URLEncode(version)).then(data => {
            if (data.HasError == true) {
                return null;
            }

            if (PropertyID == null) {
                if (data != null && data.length > 0) {
                    // PropertyID = data[0].PropertyId
                    const Guest_GroupByProp = groupBy('PropertyId', data);
                    for (const key of Object.keys(Guest_GroupByProp)) {
                        this.AddToGuestLookupCache(+key, Guest_GroupByProp[key]);
                    }
                }
            } else {
                this.AddToGuestLookupCache(PropertyID, data);
            }
            //this.AddToGuestLookupCache(PropertyID, data);
            //console.info(data);
            return data;
        });
    }

    Guest_Search(req: GuestSearch, trackLoading: boolean): Promise<ListResponse> {
        return this.apiService.postAPI(this.BaseURL, "PMS/Guest_Search", req, trackLoading).then(data => {

            if (data != null && data.Result != null && data.Result.length > 0) {
                this.SetUpcomingForGuestSearch(data.Result);

            }

            return data;
        });
    }

    Guest_GetByID(GuestId: number, TritonReservationId: number, SendReservations: boolean, trackLoading: boolean): Promise<any> {
        let req: GuestSearch = new GuestSearch();
        req.GuestId = GuestId;
        req.TritonReservationId = TritonReservationId;
        req.SendReservations = SendReservations;

        return this.Guest_Search(req, trackLoading).then(data => {
            if (data == null || data.Result == null || data.Result.length == 0)
                return null;

            let row = data.Result[0];
            return row;
        })
    }

    SetUpcomingForGuestSearch(Result: Array<any>): Array<any> {
        for (let i = 0; i < Result.length; i++) {
            let row = Result[i];

            if (row.CurrentReservations != null && row.CurrentReservations.length > 0) {
                row.UpcomingReservation = row.CurrentReservations[0];

                if (row.UpcomingReservation != null)
                    row.UpcomingReservation.LocationDescription = this.masterService.MasterData_GetMutli(row.PropertyId, row.UpcomingReservation.LocationId, enumModels.EntityCodes.Location, row.UpcomingReservation.LocationDescription);
            }
        }

        return Result;
    }

    Guest_AddPreference(req: AddPreferenceRequest): Promise<any> {
        if (req == null)
            return null;

        return this.apiService.postAPI(this.BaseURL, "PMS/Guest_AddPreference", req).then(data => {
            if (data == null)
                return null;

            return data;
        });
    }

    Guest_DeletePreference(GuestId: number, CallDescriptionId: number): Promise<any> {
        return this.apiService.getAPI(this.BaseURL, "PMS/Guest_DeletePreference?GuestId=" + GuestId + "&CallDescriptionId=" + CallDescriptionId).then(data => {
            if (data == null)
                return null;

            return data;
        });
    }

    CurrentReservations_Search_Multi(req: ListResponse): void {
        if (req == null)
            return;

        if (req.Result == null)
            return;

        for (let i = 0; i < req.Result.length; i++) {
            let row = req.Result[i];

            let propId = row.PropertyId;

            row.LocationDescription = this.masterService.MasterData_GetMutli(propId, row.LocationId, enumModels.EntityCodes.Location, row.LocationDescription);
            row.PropertyCode = this.masterService.GetProperty(propId).PropertyCode;            
        }
    }

    GetHKStatusReport(propertyId: any): Promise<ListResponse> {
        return this.apiService.getAPI(this.BaseURL, "PMS/GetHKStatusReport?PropertyId=" +propertyId).then(data => {
                return data;
            });
    }
    CurrentReservations_Search(req: CurrentReservationSearch, trackLoading: boolean): Promise<ListResponse> {
        return this.apiService.postAPI(this.BaseURL, "PMS/CurrentReservations_Search", req, trackLoading).then(data => {
            if (data != null && data.HasError == false) {
                this.CurrentReservations_Search_Multi(data);
            }
            return data;
        });
    }

    CurrentReservations_StatusCounts(request: ReservationStatusCount, trackLoading: boolean): Promise<any> {
        return this.apiService.postAPI(this.BaseURL, "PMS/CurrentReservations_StatusCounts", request, trackLoading).then(data => {
            let DueOutCount = data.find(a => a.ReservationStatus == '6');
            if (DueOutCount) {
                let preArrivalCount = data.find(a => a.ReservationStatus == '1');//.Count += DueOutCount.Count;
                if (preArrivalCount && preArrivalCount.Count)
                    preArrivalCount.Count += DueOutCount.Count;
                else {
                    let preArrivalData = {
                        propertyId: request.PropertyId,
                        ReservationStatus: 1,
                        Count: DueOutCount.Count
                    }
                    data.push(preArrivalData);
                }
            }
            return data;
        });
    }

    CurrentReservations_SetAlert(req: GuestAlert): Promise<SimpleResponse> {
        if (req == null)
            return null;

        return this.apiService.postAPI(this.BaseURL, "PMS/Guest_SetAlert", req, true).then(data => {
            if (data.HasError)
                return data;
            return data;
        });
    }

    UploadImage(req: UploadImageRequest): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, "PMS/Guest_UploadImage", req, false).then(data => {
            this.GuestImageUpdated.emit(true);
            return data;
        })
    }

    Reservation_GetTraces(req: ReservationTracesRequest, trackLoading: boolean): Promise<SimpleResponse<ReservationTrace[]>> {
        return this.apiService
            .postAPI(this.BaseURL, "PMS/GetTracesForGuest", req, trackLoading)
            .then(resp => this.transformReservationTraces(resp));
    }

    private transformReservationTraces(resp): SimpleResponse<ReservationTrace[]> {
        if(!resp || resp.HasError) {
            return resp;
        }
        resp.Result = (resp.Result || []).map(item => {
            const transformed = new ReservationTrace();
            Object.assign(transformed, item);
            transformed.TraceUUID = UUID.UUID();
            transformed.TraceDate = item.TraceDate ? DateTime.fromISO(item.TraceDate).toJSDate() : item.TraceDate;
            return transformed;
        })
        return resp;
    }
}
